// extracted by mini-css-extract-plugin
export default {"simpleBlueBtn":"simpleBlueBtn_w23L1","simpleBigBtn":"simpleBigBtn_rab0P","simpleLargeBtn":"simpleLargeBtn_1m5o7","simpleWhiteBtn":"simpleWhiteBtn_+lFTZ"};